import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Higher-Order Component that provides React Router v6 navigation functionality
 * to class components, similar to the old withRouter HOC
 */
function withNavigate(Component) {
  function ComponentWithNavigationProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create a history-like object for backward compatibility
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (delta) => navigate(delta),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location: location,
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={{ params, path: location.pathname }}
        navigate={navigate}
      />
    );
  }

  ComponentWithNavigationProp.displayName = `withNavigate(${Component.displayName || Component.name})`;

  return ComponentWithNavigationProp;
}

export default withNavigate;
